import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-[#fdfbf7] ${className}`} data-id="element-321">
      <div className="container mx-auto px-4" data-id="element-322">
        {title && <h2 className="font-bold text-center mb-12 text-[#1a3622] text-[16px] md:text-2xl" data-id="element-323">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-324">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-lg border border-[#e2e8f0] flex flex-col h-full" data-id="element-325">
              <div className="flex items-center gap-1 mb-4" data-id="element-326">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-[#d4af37] fill-[#d4af37]" data-id="element-327" />)}
              </div>

              <p className="text-[#4a3b32] italic mb-6 flex-grow" data-id="element-328">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-[#e2e8f0]" data-id="element-329">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-330">
                  {t.initials}
                </div>
                <div data-id="element-331">
                  <p className="font-bold text-[#1a3622] text-sm" data-id="element-332">{t.name}</p>
                  <p className="text-xs text-[#5c4033]" data-id="element-333">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-[#8b5a2b] mt-0.5" data-id="element-334">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'MP',
  name: 'Estudiante de Tecnicatura Agropecuaria',
  location: 'Córdoba, Argentina',
  text: 'Por fin encontré material agropecuario en español que realmente tiene profundidad. Los libros de ganadería son increíbles — desde anatomía hasta producción bovina. No encontré nada igual en este precio.',
  color: 'bg-[#2c4c3b]'
}, {
  initials: 'RL',
  name: 'Docente agropecuario',
  location: 'Santa Fe, Argentina',
  text: 'Soy docente y usé los tomos para armar mis clases de agricultura. El material sobre suelos y fertilización es exactamente lo que mis alumnos necesitaban. Claro, visual y técnico al mismo tiempo.',
  color: 'bg-[#5c4033]'
}, {
  initials: 'JG',
  name: 'Productor ganadero',
  location: 'Entre Ríos, Argentina',
  text: 'Tengo un pequeño campo y quería entender más sobre sanidad animal y reproducción. Este pack me dio más información útil que años buscando en internet. Vale diez veces lo que cuesta.',
  color: 'bg-[#8b5a2b]'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'LM',
  name: 'Estudiante de Veterinaria',
  location: 'Rosario, Argentina',
  text: 'Los libros de ganadería me salvaron en los finales. Antes buscaba información en diez lugares distintos y siempre me faltaba algo. Con este pack tuve todo organizado desde el primer día.',
  color: 'bg-[#2c4c3b]',
  pack: 'MegaPack Educación Agropecuaria y Ganadera 360'
}, {
  initials: 'RV',
  name: 'Productor ganadero',
  location: 'La Pampa, Argentina',
  text: 'Soy productor y quería entender mejor el manejo sanitario de mis animales. El libro de sanidad animal y el módulo de producción bovina me dieron más herramientas que cualquier curso que hice antes.',
  color: 'bg-[#5c4033]',
  pack: 'MegaPack Educación Agropecuaria y Ganadera 360'
}, {
  initials: 'PT',
  name: 'Docente agropecuario',
  location: 'Tucumán, Argentina',
  text: 'Lo uso para preparar mis clases de agro. El material sobre suelos, fertilización y tecnología es exactamente lo que mis alumnos necesitan — claro, técnico y bien organizado. Nunca más improviso.',
  color: 'bg-[#8b5a2b]',
  pack: 'MegaPack Educación Agropecuaria y Ganadera 360'
}, {
  initials: 'MF',
  name: 'Técnico agropecuario',
  location: 'Corrientes, Argentina',
  text: 'El módulo de producción bovina solo ya justifica el precio del pack entero. Cría, recría, engorde y tambo explicados de manera completa y práctica. No encontré nada igual.',
  color: 'bg-[#1a3622]',
  pack: 'MegaPack Educación Agropecuaria y Ganadera 360'
}, {
  initials: 'CB',
  name: 'Docente de escuela agrotécnica',
  location: 'Buenos Aires, Argentina',
  text: 'Los cuadernos de actividades del bono son excelentes. Los uso con mis alumnos para fijar los contenidos teóricos. El aprendizaje es mucho más profundo cuando practican con ejercicios reales.',
  color: 'bg-[#2c4c3b]',
  pack: 'MegaPack Educación Agropecuaria y Ganadera 360'
}];